<div class="space-y-2">
  <div *ngFor="let option of options; let i = index; trackBy: trackByOption">
    <lis-radio [key]="option.key" [label]="option.label" [groupId]="groupId" [control]="control"></lis-radio>
  </div>
</div>
